import { Component } from "@angular/core";

@Component({
        standalone: false,
    templateUrl: "./viewNoResponse.component.html",
})
export class ClosedNoResponseAccessComponent {}
